import axios from "axios";
import { Global } from "../../config/global";


export const endSession = async (session, onSelectedSession, sessions, IdChat) => { //Función para finalizar una sesión
    try {
        let token = localStorage.getItem('token'); // Extraer el token del localStorage.
        let url = Global.url + `chat/sessions/end/${session.IdSession}/${IdChat}`;
        let headers = { // Definir el encabezado de la petición.
            Authorization: `Bearer ${token}`
        };
        const response = await axios.post(url, {}, { headers });
        onSelectedSession({})
    } catch (error) {
        console.log("Error al finalizar la sesión:", error);
    }
}